import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { COMPOUND_OPERATOR_AND, COMPOUND_OPERATOR_OR, creators, JastBuilder, OPERATOR_EQUALS, OPERATOR_IN, OPERATOR_LIKE, ORDER_BY_DIRECTION_ASC, ORDER_BY_DIRECTION_DESC, print } from '@atlaskit/jql-ast';
import { availableBasicFilterTypes } from '../basic-filters/ui';
var fuzzySearchRegExp = /^"(.+)"$/;
var jiraIssueKeyRegExp = /[A-Z]+-\d+/;
export var fuzzyCharacter = '*';
var constructTerminalClause = function constructTerminalClause(field, operator, value) {
  return creators.terminalClause(creators.field(field), creators.operator(operator), creators.valueOperand(value));
};
export var buildJQL = function buildJQL(input) {
  /**
   * Jql ast - Transforming the ast
   * https://atlaskit.atlassian.com/packages/jql/jql-ast/docs/transforming-the-ast
   */
  var jast = new JastBuilder().build('');
  var query = jast.query;
  var rawSearch = input.rawSearch,
    _input$orderDirection = input.orderDirection,
    orderDirection = _input$orderDirection === void 0 ? ORDER_BY_DIRECTION_DESC : _input$orderDirection,
    _input$orderKey = input.orderKey,
    orderKey = _input$orderKey === void 0 ? 'created' : _input$orderKey,
    filterValues = input.filterValues;
  var trimmedRawSearch = rawSearch.trim();
  var hasValidFilterSelectionAndValues = filterValues &&
  // checks if filterValues have only valid keys
  Object.entries(filterValues).every(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return availableBasicFilterTypes.includes(key);
  }) &&
  // checks if atleast one fitler value has some selection object
  Object.values(filterValues).some(function (value) {
    return value.length > 0;
  });
  if (!query) {
    return '';
  }
  if (trimmedRawSearch) {
    var fuzzy = !trimmedRawSearch.match(fuzzySearchRegExp) ? fuzzyCharacter : '';
    var basicSearch = trimmedRawSearch.replace(/['"?*]+/g, '');
    var text = constructTerminalClause('text', OPERATOR_LIKE, "".concat(basicSearch).concat(fuzzy));
    var summary = constructTerminalClause('summary', OPERATOR_LIKE, "".concat(basicSearch).concat(fuzzy));
    var orClauseFields = [text, summary];
    if (jiraIssueKeyRegExp.test(trimmedRawSearch.toUpperCase())) {
      var key = constructTerminalClause('key', OPERATOR_EQUALS, basicSearch);
      orClauseFields.push(key);
    }
    var orClause = creators.compoundClause(creators.compoundOperator(COMPOUND_OPERATOR_OR), orClauseFields);
    query.appendClause(orClause, COMPOUND_OPERATOR_AND);
  }
  if (hasValidFilterSelectionAndValues) {
    Object.entries(filterValues).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        filterFieldValues = _ref4[1];
      if (filterFieldValues.length === 0) {
        return;
      }
      var filterInClause = creators.terminalClause(creators.field(key), creators.operator(OPERATOR_IN), creators.listOperand(filterFieldValues.map(function (filterFieldValue) {
        return creators.valueOperand(filterFieldValue.value);
      })));
      query.appendClause(filterInClause, COMPOUND_OPERATOR_AND);
    });
  }
  var orderField = creators.orderByField(creators.field(orderKey));
  query.prependOrderField(orderField);
  query.setOrderDirection(creators.orderByDirection(orderDirection.toLowerCase() === 'asc' ? ORDER_BY_DIRECTION_ASC : ORDER_BY_DIRECTION_DESC));
  return print(jast, {
    printWidth: null // this ensures jql string is not broken to new line
  });
};